<template>

  <header class="bg-dark dk header navbar navbar-fixed-top-xs">   


    <div class="navbar-header aside-md">      
      <a class="navbar-brand" data-toggle="fullscreen"><img src="../../assets/images/hamburger-menu.png" class="m-r-sm" style="margin-right:3px; margin-left:8px;max-height: 25px;cursor:pointer;" @click="ChangeShowSideMenu"></a>
      <a class="navbar-brand" data-toggle="fullscreen"><img src="../../assets/images/LogoDMSBianco.png" class="m-r-sm" style="margin-right:3px; max-height: 36px"></a>
      <a class="btn btn-link visible-xs" data-toggle="dropdown" data-target=".nav-user" @click="MenuMobile = !MenuMobile">
        <i class="fa fa-bars"></i>
      </a>
    </div>    
    <div v-if="MenuMobile" style="position: relative; right: 0; color: #000; background-color: #fdfdfd">  
      <div v-for="Voce in VociMenu" :key="Voce" @click="VaiA(Voce.Destinazione)" class="ZMMenuButton">
        <a style="margin-left: 5px; margin-right: 5px"><i :class="Voce.Icona"></i></a>
        <p>{{ Voce.Descrizione }}</p>
      </div>
    </div>

    <div v-if="MostraSelettoreCatena || ListaSiti.length" class="ZMHeaderSelettori">
      <div v-if="ListaSiti.length" class="ZMHeaderSitoSelect">
        <VueMultiselect
          ref="SelettoreSito"
          :model-value="SitoSelezionatoCorrente"
          :options="ListaSiti"
          label="NOME"
          track-by="CHIAVE"
          :searchable="true"
          :close-on-select="true"
          :allow-empty="false"
          :show-labels="false"
          :internal-search="true"
          placeholder=""
          @update:model-value="OnSelezionaSito"
        >
          <template #option="{ option }">
            <span class="fa fa-circle ZMHeaderSitoPriorita" :style="{ color: ColorePriorita(option.PRIORITA) }"></span>
            <span>{{ option.NOME }}</span>
          </template>
          <template #singleLabel="{ option }">
            <span class="ZMHeaderSitoNome">{{ option.NOME }}</span>
          </template>
        </VueMultiselect>
      </div>
      <div v-if="MostraSelettoreCatena" class="ZMHeaderSitoSelect">
        <VueMultiselect
          ref="SelettoreCatena"
          :model-value="CatenaSelezionataCorrente"
          :options="ListaCatene"
          label="DESCRIZIONE"
          track-by="CHIAVE"
          :searchable="true"
          :close-on-select="true"
          :allow-empty="false"
          :show-labels="false"
          :internal-search="true"
          placeholder=""
          @update:model-value="OnSelezionaCatena"
        >
          <template #singleLabel="{ option }">
            <span class="ZMHeaderSitoNome">{{ option.DESCRIZIONE }}</span>
          </template>
        </VueMultiselect>
      </div>
    </div>

    <ul class="nav navbar-nav navbar-right m-n hidden-xs nav-user">
      <!-- <li class="hidden-xs" v-if="UserInformation.Ruolo != 'A' && $route.params.pagina != 'SchedaMessaggi'">
        <a  @click="GoToMessaggi" @load="ConteggiomessaggiNonLetti">
          <i class="fa fa-bell"></i>
          <span v-if="Notifiche > 0" class="badge badge-sm up bg-danger m-l-n-sm count">{{Notifiche}}</span>
        </a>
      </li> -->
      <li class="hidden-xs" v-if="DeveloperMode">
        <button style="margin-top:7px" @click="OnClickBottoneDiProva" class="btn btn-info btn-rounded">Bottone di prova</button>
      </li>
      <li class="dropdown open"  style="z-index:9999;">
          <a style="cursor:pointer" @click="OnClick" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="true">
            <span class="thumb-sm avatar pull-left">
              <img v-if="UserInformation.Immagine != '' && UserInformation.Immagine != null" :src="UserInformation.Immagine" style="max-width:30px; max-height:30px; min-width:30px; min-height:30px">
              <img v-else src="@/assets/images/avatar_default.jpg">
            </span>
            {{ UserInformation.RagioneSociale }} <b class="fa" :class="{ 'fa-sort-up' : aperto, 'fa-sort-down' : !aperto }" ></b>
          </a>
          <ul class="dropdown-menu" v-if="aperto">
            <li>
              <a style="cursor:pointer" @click="OnClickLogout">{{GetTraduzioneLabel("VUEAppHeader", "TKN_LOGOUT", LinguaUtente)}}</a>
            </li>
            <li>
              <a style="cursor:pointer" @click="OnClickPopupProfilo">{{ GetTraduzioneLabel("VUEAppHeader", "TKN_MODIFICA_PROFILO", LinguaUtente)}}</a>
            </li>
            <li>
              <a style="cursor:pointer" @click="OnClickPopupPassword">{{ GetTraduzioneLabel("VUEAppHeader", "TKN_MODIFICA_PASSWORD", LinguaUtente)}}</a>
            </li>
            <li class="divider"></li>
            <li>
              <a style="cursor:pointer" @click="OnClickGoToVersione">{{GetTraduzioneLabel("VUEAppHeader", "TKN_VERSIONE", LinguaUtente)}} {{ VersioneSoftware }}</a>
            </li>
            <li class="divider"></li>
            <li>
              <a @click="OnClick">{{GetTraduzioneLabel("Generic", "TKN_CHIUDI", LinguaUtente)}}</a>
            </li>
          </ul>
        </li>
    </ul>      
  </header>

  <VUEModal v-if="profilomodifica" :Titolo="this.GetTraduzioneLabel('VUEAppHeader','TKN_HEAD_MOD_PROFILO',this.LinguaUtente)" :Altezza="'450px'" :Larghezza="'1000px'" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaModificaProfilo" @onClickConfermaModal="ConfermaModificaProfilo">
    <template v-slot:Body>
      <div class="form-row">
        <br>
        <div class="col-md-12">                
          <div class="col-md-3">  
            <div href="javascript:;" v-if="UserInformationEdit.Immagine != ''">
              <img style="height:200px; max-height:200px; max-width:200px; min-height:200px; min-width:200px" :src="UserInformationEdit.Immagine" class="img-circle">
            </div>
            <div href="javascript:;" v-else>
              <img style="height:200px" src="@/assets/images/avatar_default.jpg" class="img-circle">
            </div>
              <br>
            <div>
              <label class="btn" type="button" style="cursor:pointer;width:100%;background-color:white; width:200px">{{ this.GetTraduzioneLabel('VUEAppHeader','TKN_PROFILO_NUOVA_IMG',this.LinguaUtente) }}        
                <input style="display:none;" type="file" id="inputImmagineUtente" @change="LoadImmagineFromFile(elemento)" accept="image/*">
              </label>                     
            </div>
          </div>
          <div class="col-md-1"></div>
          <div class="col-md-8">
            <div>{{ this.GetTraduzioneLabel('VUEAppHeader','TKN_PROFILO_RAG_SOCIALE',this.LinguaUtente) }} <input class="form-control" style="width:100%" type="text" v-model="UserInformationEdit.RagioneSociale"></div>
            <br>
            <div>{{ this.GetTraduzioneLabel('VUEAppHeader','TKN_PROFILO_EMAIL',this.LinguaUtente) }} <input class="form-control" style="width:100%" type="text" v-model="UserInformationEdit.EMail"></div>
            <br>
            <div class="form-row" style="font-size:14px">
              <label>{{ this.GetTraduzioneLabel('VUEAppHeader','TKN_PROFILO_SENSIBIL_MOUSE',this.LinguaUtente) }}</label>
              <br>
              <VUESlider style="width:50%" :min="1" :max="20" v-model="UserInformationEdit.SensibilitaScroll"></VUESlider>
            </div>
            <br>
            <div class="form-row" style="font-size:14px">
              <label>{{ this.GetTraduzioneLabel('VUEAppHeader','TKN_PROFILO_FUSO_ORARIO',this.LinguaUtente) }}</label>
              <br>
              <select class="form-control" v-model="UserInformationEdit.FusoOrario">
                <option v-for="Fuso in FusiOrari" :key="Fuso">{{ Fuso }}</option>
              </select>
            </div>
            <br>
            <div  class="form-row" style="font-size:14px">
              {{ this.GetTraduzioneLabel('VUEAppHeader','TKN_PROFILO_RICARICA_DATI',this.LinguaUtente) }} 
              <input class="form-control" style="display: inline; white-space: nowrap; width: 78px;" type="number" v-model="UserInformationEdit.AutorefreshDati">
              {{ this.GetTraduzioneLabel('UdmGenerali','TKN_MN',this.LinguaUtente) }}</div>
            <br>
            <div class="form-row" style="font-size:14px">
              <label>{{ this.GetTraduzioneLabel('VUEAppHeader','TKN_PROFILO_LINGUA',this.LinguaUtente) }}</label>
              <br>
              <select class="form-control" v-model="UserInformationEdit.Lingua">
                <option v-for="Lingua in VettoreLingue" :key="Lingua.Chiave">{{ Lingua.Lingua }}</option>
              </select>
            </div>
          </div>
        </div>
      </div> 
    </template>
  </VUEModal>
  <VUEModal v-if="passwordmodifica" :Titolo="this.GetTraduzioneLabel('VUEAppHeader','TKN_HEAD_MOD_PASSWORD',this.LinguaUtente)" :Altezza="'400px'" :Larghezza="'1000px'" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaModificaPassword">
    <template v-slot:Body>
      <div class="form-row" style="font-size:14px">
        <ul>{{ this.GetTraduzioneLabel('VUEAppHeader','TKN_CHECK_PASSWORD',this.LinguaUtente) }}:
          <li>{{ this.GetTraduzioneLabel('VUEAppHeader','TKN_CHECK_PASSWORD_LENGHT',this.LinguaUtente) }};
            <span v-if="CheckNumeroCaratteri && CheckSpazi" class="fa fa-check" style="color:#33ff33; font-size: 15px"></span>
            <span v-else class="fa fa-times" style="color:#cb4d4d; font-size: 15px"></span>
          </li>
          <li>{{ this.GetTraduzioneLabel('VUEAppHeader','TKN_CHECK_PASSWORD_CAPS',this.LinguaUtente) }};
            <span v-if="CheckMinuscole && CheckMaiuscole" class="fa fa-check" style="color:#33ff33; font-size: 15px"></span>
            <span v-else class="fa fa-times" style="color:#cb4d4d; font-size: 15px"></span>                
          </li>
          <li>{{ this.GetTraduzioneLabel('VUEAppHeader','TKN_CHECK_PASSWORD_CHAR',this.LinguaUtente) }}: $-/:-?{-~!"^_}@`[];
            <span v-if="CheckSpeciali" class="fa fa-check" style="color:#33ff33; font-size: 15px"></span>
            <span v-else class="fa fa-times" style="color:#cb4d4d; font-size: 15px"></span>
          </li>
          <li>{{ this.GetTraduzioneLabel('VUEAppHeader','TKN_CHECK_PASSWORD_NUM',this.LinguaUtente) }};
            <span v-if="CheckNumeri" class="fa fa-check" style="color:#33ff33; font-size: 15px"></span>
            <span v-else class="fa fa-times" style="color:#cb4d4d; font-size: 15px"></span>
          </li>
        </ul>
        <br>
        <div class="col-md-12">               
          <div>{{ this.GetTraduzioneLabel('VUEAppHeader','TKN_CHECK_PASSWORD_OLD',this.LinguaUtente) }}: <input type="password" class="form-control" style="width:100%" v-model="Password.Vecchia"></div>
          <br>
          <div>{{ this.GetTraduzioneLabel('VUEAppHeader','TKN_CHECK_PASSWORD_NEW',this.LinguaUtente) }}: <input type="password" class="form-control" style="width:100%" v-model="Password.Nuova"></div>
          <br>
          <div>{{ this.GetTraduzioneLabel('VUEAppHeader','TKN_CHECK_PASSWORD_REPEAT',this.LinguaUtente) }}: <input type="password" class="form-control" style="width:100%" v-model="Password.Ripeti"></div>
        </div>
        <br>
        <ul v-if="!CheckRipetiPassword && Password.Nuova != ''">{{ this.GetTraduzioneLabel('VUEAppHeader','TKN_CHECK_PASSWORD_SAME',this.LinguaUtente) }}</ul>
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:18%" @click="AnnullaModificaPassword" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="CheckPassword" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:18%" @click="ConfermaModificaPassword" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>
</template>

<script>
import { COLORI_PANTONE, COLORI_PRIORITA, RUOLI, NUMERO_VERSIONE_DMSEW, SystemInformation, LOCALSTORAGE } from '@/SystemInformation';
import VueMultiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.css'
import { TZImageFunct } from '@/utils/ZImageFunct.js'
import VUEModal from '@/utils/VUEModal.vue';
import VUESlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import { reactive, toRefs } from 'vue'
import { TZGenericFunct } from '@/utils/ZGenericFunct';
import { TIME_ZONES } from '@/utils/ZDateFunct';
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';

export default
{
   mixins: [ MixInsGestioneTraduzioni ],
   components: { VUEModal, VUESlider, VueMultiselect },
   setup() {
    const data = reactive({ value: 10 })
    return toRefs(data)
  },
   props: {
            VisualizzaMenu: {},
            SitoSelezionato: { type: Object, default: () => ({}) },
            ListaSiti: { type: Array, default: () => [] },
            CatenaSelezionata: { type: Object, default: () => ({}) },
            ListaCatene: { type: Array, default: () => [] },
          },
   emits: ['onClickCambiaMenu', 'onSelezionaSito', 'onSelezionaCatena'],
   data()
   {
      return {
              UserInformation      : SystemInformation.UserInformation,
              DeveloperMode        : SystemInformation.DeveloperMode,
              aperto               : false,
              profilomodifica      : false,
              passwordmodifica     : false,
              UserInformationEdit  : {},
              Password             : {},
              Notifiche            : 10,
              Arancione            : COLORI_PANTONE.Arancione,
              Marrone              : COLORI_PANTONE.Marrone,
              Admin                : false,
              MenuMobile           : false,
              VociMenu             : [],
              FusiOrari            : TIME_ZONES,
              VersioneSoftware     : NUMERO_VERSIONE_DMSEW,
              VettoreLingue        : SystemInformation.ListaLingue,
              LinguaUtente         : SystemInformation.UserInformation.Lingua,
              Popup                : false,
              ColoriPriorita       : COLORI_PRIORITA,
      };
   },
   beforeMount()
   {
      this.UserInformationEdit =  {
                                    RagioneSociale    : this.UserInformation.RagioneSociale,
                                    EMail             : this.UserInformation.EMail,
                                    Immagine          : this.UserInformation.Immagine,
                                    Ruolo             : this.UserInformation.Ruolo,
                                    SensibilitaScroll : this.UserInformation.SensibilitaScroll,
                                    FusoOrario        : this.UserInformation.FusoOrario,
                                    AutorefreshDati   : this.UserInformation.AutorefreshDati,
                                    Lingua            : this.UserInformation.Lingua,
                                  }

      if (this.UserInformationEdit.Immagine == undefined)
      {
        this.UserInformationEdit.Immagine = ''
      }
      this.Password            =  {
                                    Nuova          : '',
                                    Ripeti         : '',
                                    Vecchia        : ''
                                  }
      this.Admin = SystemInformation.UserInformation.Ruolo == RUOLI.Amministratore

      this.VociMenu = [
                        {Descrizione : this.GetTraduzioneLabel('VUEAppHeader','TKN_MENU_DASH_MOBILE',this.LinguaUtente), Icona : "fa fa-dashboard", Destinazione : "/appMainWindow/Dashboard"}
                      ]
      if (this.Admin)
      {
        this.VociMenu.push({Descrizione : this.GetTraduzioneLabel('VUEAppHeader','TKN_MENU_GESTIONE_SITI_MOBILE',this.LinguaUtente), Icona : "fa fa-pencil", Destinazione : "/appMainWindow/GestioneSiti"})
        this.VociMenu.push({Descrizione : this.GetTraduzioneLabel('VUEAppHeader','TKN_MENU_GESTIONE_UTENTI_MOBILE',this.LinguaUtente), Icona : "fa fa-user", Destinazione : "/appMainWindow/GestioneUtenti"})
        this.VociMenu.push({Descrizione : this.GetTraduzioneLabel('VUEAppHeader','TKN_MENU_GESTIONE_MESSAGGI_MOBILE',this.LinguaUtente), Icona : "fa fa-envelope", Destinazione : "/appMainWindow/GestioneMessaggi"})
      }
      this.ConteggiomessaggiNonLetti()
   },

   mounted()
   {
   },
   methods :
   {
      ConteggiomessaggiNonLetti()
      {
        
        // if (SystemInformation.UserInformation.Ruolo != 'A')
        // {
        //   let Self = this
        //   SystemInformation.AdvQuery.GetSQL('Utenti_Messaggi', {},
        //   function(Results)
        //   {
        //     let Messaggi = SystemInformation.AdvQuery.FindResults(Results,"MessaggiCount")
        //     let MessaggiLetti = SystemInformation.AdvQuery.FindResults(Results,'MessaggiLettiCount')
        //     Self.Notifiche = Messaggi[0].COUNT - MessaggiLetti[0].COUNT_LETTI
        //   }, SystemInformation.HandleError, 'SelectNotifiche')
        // }
      },

      VaiA(Destinazione)
      {
        this.$router.push(Destinazione)
        this.MenuMobile = false
      },

      OnClick()
      {
        this.aperto = !this.aperto
      },
      OnClickPopupProfilo()
      {
        this.profilomodifica = true
        this.aperto = false 
      },
      ConfermaModificaProfilo()
      {
        var ObjQuery = {Operazioni : []}
        var Self = this
        ObjQuery.Operazioni.push(
                        {
                          Query : 'ModificaProfilo',
                          Parametri : {
                                          RagioneSociale : this.UserInformationEdit.RagioneSociale,
                                          EMail          : this.UserInformationEdit.EMail,
                                          Immagine       : this.UserInformationEdit.Immagine,
                                          UserName       : this.UserInformation.UserName,
                                          Scroll         : this.UserInformationEdit.SensibilitaScroll,
                                          FusoOrario     : this.UserInformationEdit.FusoOrario,
                                          AutorefreshDati: this.UserInformationEdit.AutorefreshDati,
                                          Lingua         : this.UserInformationEdit.Lingua,
                          }
                       })
        SystemInformation.AdvQuery.PostSQL('ModificaProfilo', ObjQuery, function(){
                                                                                    Self.profilomodifica = false
                                                                                    SystemInformation.UserInformation.SensibilitaScroll = Self.UserInformationEdit.SensibilitaScroll
                                                                                    window.location.reload();
                                                                                  }, SystemInformation.HandleError)
      },
      AnnullaModificaProfilo()
      {
        this.profilomodifica = false
        this.UserInformationEdit.RagioneSociale =this.UserInformation.RagioneSociale,
        this.UserInformationEdit.EMail =this.UserInformation.EMail,
        this.UserInformationEdit.Immagine =this.UserInformation.Immagine,
        this.UserInformationEdit.Immagine =this.UserInformation.Ruolo,
        this.UserInformationEdit.SensibilitaScroll =this.UserInformation.SensibilitaScroll,
        this.UserInformationEdit.FusoOrario =this.UserInformation.FusoOrario,
        this.UserInformationEdit.AutorefreshDati =this.UserInformation.AutorefreshDati
        this.UserInformationEdit.Lingua =this.UserInformation.Lingua
      },
      OnClickPopupPassword()
      {
        this.passwordmodifica = true
        this.aperto = false
      },
      OnClickGoToVersione()
      {
        this.aperto = false
        let URL = '/appMainWindow/VersioneDMSEW'
        window.location.hash = URL
      },
      OnClickLogout()
      {
        localStorage.clear();
        localStorage.setItem(LOCALSTORAGE.LanguageDMSEW, this.LinguaUtente);
        this.$router.push('/')
        this.$router.go()
      },

      ShowButton()
      {
        if (this.Admin)
          return false
        return this.$route.path != '/appMainWindow/Dashboard'
      },

      TornaAllaDashboard()
      {
        let Parametri = TZGenericFunct.GetURLParameters()
        this.$router.push('/appMainWindow/Dashboard?ChiaveSito=' + Parametri.ChiaveSito)
      },

      LoadImmagineFromFile()
      {
        var Self    = this;
        var Reader  = new FileReader()
        var ImgFile = document.getElementById('inputImmagineUtente')
        
        var TypeImg = ImgFile.files[0].type
        Reader.readAsDataURL(ImgFile.files[0])

        Reader.onload = function (e) 
        {
           var Img = new Image()
           Img.onload = function () 
           {
              Img.onload = undefined;
              TZImageFunct.ResizeImage(Img,200,300,TypeImg) 
              Self.UserInformationEdit.Immagine = Img.src 
           }
           Img.src = e.target.result
        } 
      },
      AnnullaModificaPassword()
      {
            this.Password.Nuova     = ''
            this.Password.Ripeti    = ''
            this.Password.Vecchia   = ''
            this.passwordmodifica = false
      },

      ConfermaModificaPassword()
      {
          var Self = this
          SystemInformation.AdvQuery.ChangePassword(this.Password.Vecchia,this.Password.Nuova,
                                          function()
                                          { 
                                            Self.passwordmodifica = false
                                          },
                                          SystemInformation.HandleError);
      },

      GoToMessaggi()
      {
        this.$router.push('/appMainWindow/SchedaMessaggi')
      },

      ChangeShowSideMenu()
      {
        this.$emit('onClickCambiaMenu')
      },

      OnClickBottoneDiProva()
      {
        alert('Esco solo in debug mode')
        // this.Popup = true
      },

      ColorePriorita(Priorita)
      {
        if (Priorita == null || Priorita < 1 || Priorita > this.ColoriPriorita.length)
          return this.ColoriPriorita[this.ColoriPriorita.length - 1]
        return this.ColoriPriorita[Priorita - 1]
      },

      OnSelezionaSito(Sito)
      {
        if (Sito != null && Sito.CHIAVE != this.SitoSelezionato.CHIAVE)
          this.$emit('onSelezionaSito', Sito.CHIAVE)
      },

      OnSelezionaCatena(Catena)
      {
        if (Catena != null && Catena.CHIAVE != this.CatenaSelezionata.CHIAVE)
          this.$emit('onSelezionaCatena', Catena.CHIAVE)
      }
    },
    computed :
    {
        VisualizzazioneMenuLaterale:
        {
          get()
          {
            return this.VisualizzaMenu
          }
        },

        CurrentRouter:
        {
          get()
          {
              return this.$route.fullPath 
          }
        },

        CheckPassword()
        {
            if(this.CheckSpazi)
            {
                if( this.CheckNumeroCaratteri && this.CheckRipetiPassword &&
                    this.CheckNumeri && this.CheckMinuscole
                    && this.CheckMaiuscole && this.CheckSpeciali)
                    return true
            }
            return false            
        },
        CheckSpazi()
        {
            let check5=/\s/
            if(check5.test(this.Password.Nuova))
                return false
            return true
        },          
        CheckNumeri()
        {
            let check=/[0-9]/
            if(check.test(this.Password.Nuova))
                return true
            return false
        },
        CheckSpeciali()
        {
            let check4=/[$-/:-?{-~!"^_}@`[\]]/
            if(check4.test(this.Password.Nuova))
                return true
            return false
        },
        CheckMinuscole()
        {
            let check2=/[a-z]/
            if(check2.test(this.Password.Nuova))
                return true
            return false
        },
        CheckMaiuscole()
        {
            let check3=/[A-Z]/
            if(check3.test(this.Password.Nuova))
                return true
            return false 
        },
        CheckNumeroCaratteri()
        {
            if (this.Password.Nuova.length >= 8)
                return true
            return false
        },
        CheckRipetiPassword()
        {
            if(this.Password.Nuova != '')
            {
                if (this.Password.Nuova == this.Password.Ripeti)
                    return true
            }
            return false
        },

        MostraSelettoreCatena()
        {
          return this.ListaCatene.length > 0 && this.CatenaSelezionata.CHIAVE != null
        },

        CatenaSelezionataCorrente:
        {
          get()
          {
            if (this.CatenaSelezionata.CHIAVE == null)
              return null
            let Catena = this.ListaCatene.find((element) => { return element.CHIAVE == this.CatenaSelezionata.CHIAVE })
            return Catena != null ? Catena : this.CatenaSelezionata
          }
        },

        SitoSelezionatoCorrente:
        {
          get()
          {
            if (this.SitoSelezionato.CHIAVE == null)
              return null
            let Sito = this.ListaSiti.find((element) => { return element.CHIAVE == this.SitoSelezionato.CHIAVE })
            return Sito != null ? Sito : this.SitoSelezionato
          }
        },
    },

    watch:
    {
     CurrentRouter:
     {
        handler(NewValue,OldValue)
        {
          if(OldValue == '/appMainWindow/SchedaMessaggi')
            this.ConteggiomessaggiNonLetti()
        }
     }
    }, 
           
}

</script>